import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';
import { ReactNode } from 'react';

const StyledDiv = styled.div`
  position: relative;
  overflow: hidden;
  background: ${({ theme }) =>
    `linear-gradient(135deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`};
  font-weight: ${({ theme }) => theme.typography.subtitle2.fontWeight};
  font-size: ${({ theme }) => theme.typography.subtitle2.fontSize};
  line-height: ${({ theme }) => theme.typography.subtitle2.lineHeight};
  letter-spacing: 0.01071em;
  vertical-align: inherit;
  border-bottom: 1px solid ${({ theme }) => alpha(theme.palette.common.white, 0.16)};
  text-align: left;
  padding: ${({ theme }) => theme.spacing(1.5, 2.5)};
  color: ${({ theme }) => theme.palette.primary.contrastText};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: radial-gradient(
      circle at 96% 0%,
      ${({ theme }) => alpha(theme.palette.secondary.main, 0.36)},
      transparent 18rem
    );
  }
`;

interface DataGridFlexSalesHeaderProps {
  children: ReactNode;
}

const DataGridFlexSalesHeader = ({ children }: DataGridFlexSalesHeaderProps) => (
  <StyledDiv>
    <span>{children}</span>
  </StyledDiv>
);

export default DataGridFlexSalesHeader;
